"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
var constants_1 = require("../constants");
var defaultState = {
  web3: null,
  web3readonly: null,
  initialized: false,
  readonly_initialized: false,
  contracts: {}
};
var reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
  var _ref = arguments.length > 1 ? arguments[1] : undefined,
    type = _ref.type,
    payload = _ref.payload;
  switch (type) {
    case constants_1.SET_WEB3_INSTANCE:
      return Object.assign(Object.assign({}, state), {
        web3: payload
      });
    case constants_1.ADD_WEB3_READONLY_INSTANCE:
      return Object.assign(Object.assign({}, state), {
        web3readonly: Object.assign(Object.assign({}, state.web3readonly), _defineProperty({}, payload.chainId, payload.web3instance))
      });
    case constants_1.SET_INITIALIZED:
      return Object.assign(Object.assign({}, state), {
        initialized: payload
      });
    case constants_1.SET_READONLY_INITIALIZED:
      return Object.assign(Object.assign({}, state), {
        readonly_initialized: payload
      });
    case constants_1.ADD_CONTRACT:
      {
        return Object.assign(Object.assign({}, state), {
          contracts: Object.assign(Object.assign({}, state.contracts), _defineProperty({}, payload.key, payload.contract))
        });
      }
    case constants_1.REMOVE_CONTRACT:
      {
        var newContracts = Object.assign({}, state.contracts);
        delete newContracts[payload];
        return Object.assign(Object.assign({}, state), {
          contracts: newContracts
        });
      }
    default:
      return state;
  }
};
exports["default"] = reducer;